<template>
	  <div class="filter-cont">
				<input type="text" :placeholder="placeholder" v-model="currentValue"  @keyup.enter = "handleSearch"/>
				<a @click="handleSearch"><i class="icon-search" ></i>搜索</a>
		</div>
</template>
<script>
/**
 * z-input
 * @module components/Search
 * @desc 搜索组件
 * @param {String} [value] - 绑定值，支持双向绑定
 * @param {String} [placeholder] - 提示语
 * @param {function} [function] - 搜索方法
 * @example
 * <z-search v-model="value" placeholder="请输入名称" @handleSearch="handleSearch"></z-search>
 */
export default {
  name: 'z-search',
  props: {
    value: {
    		type:[String,Number],
				default: ''
    },
    placeholder:{
    	type:String,
			default: ''
    }
  },
  computed: {
  	currentValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
			handleSearch(){//搜索
				this.$emit('handleSearch')
			}
		}
};
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	.filter-cont {
			position: relative;
			text-align: right;
			padding-right: px-em(160px);
			input {
				border: 1px solid $color-border;
				border-right: none;
				padding: px-em(10px) px-em(20px);
				width: px-em(500px);
				height: px-em(72px);
    		line-height: px-em(72px);
				border-radius: 3px 0 0 3px;
			}
			a {
				position: absolute;
				right: 0;
				top: 0;
				width: px-em(160px);
				text-align: center;
				height: px-em(72px);
    		line-height: px-em(72px);
				background: $color-main;
				color: $color-white;
				border-radius: 0 3px 3px 0;
				i {
					padding-right: px-em(10px);
					color: $color-white;
					font-size: px-em(24px);
				}
			}
		}
		
		@media only screen and (min-width:0px) and (max-width:640px) {
		.filter-cont input{
			width: px-em(300px);
		}
	}
</style>


// WEBPACK FOOTER //
// Search.vue?744c92bd